import React from "react";
import logo from "../../assets/images/logo-header.svg";
import worldweb from "../../assets/images/popup/Worldwide-web.png";
import icons from "../../assets/images/sprite-other-icons.svg";
import { useLocation, useNavigate } from "react-router-dom";

const SignInLayout = ({ element }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const handleBack = () => {
    navigate(-1);
    // if(location?.pathname === "/resetpage"){
    //     navigate("/signin");
    // } else{
    //     navigate(-1);
    // }
  };
  return (
    <React.Fragment>
      <div className="SB-Lite SB-nonLoggedIn SB-homePage">
        <div
          className="SB-modal SB-login-modal SB-modal-fullscreen open"
          id="SB-login-modal"
        >
          <div className="SB-modal-dialog">
            <div className="SB-modal-content">
              <div className="SB-modal-body">
                <div className="SB-loginRegister SB-login">
                  <div
                    className="SB-loginRegister-innercontainer"
                    id="SB-login-af-container"
                  >
                    <div className="SB-pageHeader">
                      <div
                        className="SB-pageBackButton"
                        id="SB-pageBackBtn"
                        data-dismiss="modal"
                        onClick={handleBack}
                      >
                        <div className="SB-iconSVG" title="back">
                          <svg xmlns="http://www.w3.org/2000/svg">
                            <use xlinkHref={`${icons}#icon-back`}></use>
                          </svg>
                        </div>
                      </div>
                      <div
                        className="SB-pageHeader-logo"
                        onClick={() => navigate("/")}
                      >
                        <img src={logo} alt="logo" />
                      </div>
                    </div>
                    <div className="SB-loginRegister-banner">
                      <div className="SB-loginRegister-discription">
                        <img
                          src={require("../../assets/images/popup/login-TopLeft.webp")}
                          alt="Reload Bonus"
                        />
                      </div>
                      <div className="SB-contentImage">
                        <img
                          src={require("../../assets/images/popup/login-TopRight.webp")}
                          alt="Reload Bonus"
                        />
                      </div>
                    </div>
                    <div className="SB-loginRegister-content">{element}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default SignInLayout;
